import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getinternalAuditHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "internalaudit", ...action.payload }),
		);
		yield put({
			type: types.GET_INTERNAL_AUDIT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_INTERNAL_AUDIT_ERROR,
			payload,
		});
	}
}

export function* getinternalAuditWatcherSaga() {
	yield takeLatest(types.GET_INTERNAL_AUDIT_START, getinternalAuditHandlerSaga);
}

//create

//delete

function* deleteinternalAuditHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("internalaudit", action.payload),
		);
		yield put({
			type: types.DELETE_INTERNAL_AUDIT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_INTERNAL_AUDIT_ERROR,
			payload,
		});
	}
}

export function* deleteinternalAuditWatcherSaga() {
	yield takeLatest(
		types.DELETE_INTERNAL_AUDIT_START,
		deleteinternalAuditHandlerSaga,
	);
}

//update
